import { Navigate, useParams } from "react-router-dom";
/** Leaving recipient selection returns to its already-saved conduct receipt. */
export function ConductNotificationExitPage() {
  const { recordId = "" } = useParams();
  return (
    <Navigate
      replace
      to={`/admin/conduct?recordId=${encodeURIComponent(recordId)}`}
    />
  );
}
